import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useInvoiceTable } from "Order/Modules/Invoice/Components/Tables/Hooks/useInvoiceListTable";
import { useInvoiceFilters } from "Order/Modules/Invoice/Hooks/useInvoiceFilters";
import { PageContainer } from "Shared/Components/Container";
import { Table } from "Shared/Components/Table/index";
import { Typography } from "@mui/material";

const invoiceResource = Resources.base.invoice.shared;

export const InvoiceListPage = () => {
	const { t } = useResource();
	const filter = useInvoiceFilters();
	const tableOptions = useInvoiceTable(filter);

	return (
		<PageContainer
			title={t(invoiceResource.heading)}
			description="List of invoices"
		>
			<Typography variant="h2" mb={2}>
				{t(invoiceResource.heading)}
			</Typography>
			<Table tableOptions={tableOptions} />
		</PageContainer>
	);
};
